import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/map';

import { AppConfig } from '../config/app.config';
import { IReturnObject } from '../shared/return-object.model';
import { SupplierContactBE } from './shared/supplier-contact.model';

@Injectable()
export class SupplierContactService {
    constructor(private config: AppConfig, private http: Http) { }

    private apiUrl: string = this.config.get('apiUrl') + 'Supplier';

    deleteContact(contactId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/DeleteContact/?id=${contactId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getContacts(supplierId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/GetContacts/?supplierId=${supplierId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    getExtendedContacts(extendedSupplierIds: string): Observable<IReturnObject> {
      return this.http.get(`${this.apiUrl}/GetExtendedContacts/?extendedSupplierIds=${extendedSupplierIds}`)
          .map((response: Response) => <IReturnObject>response.json());
  }

    updateContact(contact: SupplierContactBE): Observable<IReturnObject> {
        let headers: Headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Accept', 'application/json');
        let body = JSON.stringify(contact);
        let options = new RequestOptions({ headers: headers });

        return this.http.post(`${this.apiUrl}/UpdateContact`, body, options)
            .map((response: Response) => <IReturnObject>response.json());
    }


    updateExtendedContact(contact: SupplierContactBE): Observable<IReturnObject> {
      let headers: Headers = new Headers();
      headers.append('Content-Type', 'application/json');
      headers.append('Accept', 'application/json');
      let body = JSON.stringify(contact);
      let options = new RequestOptions({ headers: headers });

      return this.http.post(`${this.apiUrl}/UpdateContact`, body, options)
          .map((response: Response) => <IReturnObject>response.json());
  }

    markContactInfoUpdated(supplierId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/MarkContactInfoUpdated/?supplierId=${supplierId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }

    CheckForSupplierInMainStoreOrWashingSupplier(supplierId: number): Observable<IReturnObject> {
        return this.http.get(`${this.apiUrl}/CheckForSupplierInMainStoreOrWashingSupplier/?supplierId=${supplierId}`)
            .map((response: Response) => <IReturnObject>response.json());
    }


}





// WEBPACK FOOTER //
// C:/Users/NREGE3/Workspace/OnPremChina/PackITWebGui/src/app/supplier-contact/supplier-contacts.service.ts